
const VUE_APP_API_URL = process.env.VUE_APP_API_URL || ''

export { VUE_APP_API_URL }
